import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchTransactions } from "../../features/transaction/transactionSlice";
import Transaction from "./Transaction";

export default function Transactions() {
    const dispatch = useDispatch();

    const { transactions, isLoading, isError } = useSelector(
        (state) => state.transaction
    );

    useEffect(() => {
        dispatch(fetchTransactions({ latest: true }));
    }, [dispatch]);

    // decide what to render
    let content = null;
    const totalTransaction = transactions?.length || 0;
    if (isLoading) content = <p>Loading...</p>;

    if (!isLoading && isError)
        content = <p className="error">There was an error occured</p>;

    if (!isLoading && !isError && totalTransaction > 0) {
        content = transactions.slice(totalTransaction > 5 ? totalTransaction - 5 : 0).map((transaction) => (
            <Transaction key={transaction.id} transaction={transaction} />
        ));
    }

    if (!isLoading && !isError && totalTransaction === 0) {
        content = <p>No transactions found!</p>;
    }

    return (
        <>
            <p className="second_heading">Your Transactions:</p>

            <div className="conatiner_of_list_of_transactions">
                <ul>{content}</ul>
            </div>
            {totalTransaction > 5 && <Link to="/statement">
                <button style={{
                    padding: "16px 48px",
                    backgroundColor: "green",
                    border: "none",
                    color: "white",
                    borderRadius: "8px",
                    fontSize: "16px",
                    cursor: "pointer"
                }}>Show More</button>
            </Link>}
            {totalTransaction <= 5 && <h4 style={{ textAlign: "center", lineHeight: 2 }}>Statement Page will available if you have more than 5 transactions. <br />Currently you have only
                <span style={{
                    backgroundColor: "gray",
                    color: "white",
                    padding: "4px 24px 6px 24px"
                }}>{totalTransaction}</span>
                transactions.</h4>}
        </>
    );
}
